import classNames from "classnames";
import * as React from "react";
import { useTranslation } from "react-i18next";

import LinkIcon from "components/icons/LinkIcon";
import { CorporateBundle, MobileRetailBundle, ProcessorBundle, SmbBundle } from "components/licenses/bundles";
import bmpSetupStyle from "components/products/bmp-setup.scss";
import style from "components/products/current-plan/current-plan.scss";
import Heading from "components/typography/heading/Heading";
import { CombinedTier, OldLicensingModelTier } from "domain/tenants";
import { generateTenantTypeToTranslationMap, generateTierToTranslationMap } from "domain/tierRelatedMaps";
import { TenantDetails } from "store/tenantDetails";
import { useTheme } from "utils/useTheme";

export interface Props {
    tenantData: TenantDetails;
}

const CurrentPlan = (props: Props): JSX.Element => {
    const { t } = useTranslation();
    const theme = useTheme();

    const bundleToColorMap = new Map<CombinedTier, string>([
        [OldLicensingModelTier.BASIC, style.yellow],
        [OldLicensingModelTier.STANDARD, style.blue],
        [OldLicensingModelTier.ADVANCED, style.red],
        [CorporateBundle.ESSENTIALS, style.yellow],
        [CorporateBundle.POWER, style.blue],
        [CorporateBundle.ENTERPRISE, style.red],
        [ProcessorBundle.CORE, style.yellow],
        [ProcessorBundle.PRO, style.blue],
        [ProcessorBundle.PRO_SCALE, style.red],
        [SmbBundle.SELECT_50, style.yellow],
        [SmbBundle.SELECT_100, style.yellow],
        [SmbBundle.SELECT_PLUS_250, style.blue],
        [SmbBundle.SELECT_PLUS_500, style.blue],
        [MobileRetailBundle.MOBILE_RETAIL_LITE, style.yellow],
        [MobileRetailBundle.MOBILE_RETAIL_PLUS, style.blue],
        [MobileRetailBundle.MOBILE_RETAIL_PRO, style.red],
    ]);

    const getCurrentPlanStyle = (bundle: CombinedTier): string => {
        return bundleToColorMap.get(bundle) || "";
    };

    return (
        <>
            <div className={classNames(style.currentPlan, getCurrentPlanStyle(props.tenantData.tenantTier))}>
                <div>
                    <div className={style.planLabel}>{t("Onboarding.home.currentPlan")}</div>
                    <Heading tag="div" variant="SUBTITLE_2" className={style.tierTypeLabel}>
                        {props.tenantData
                            ? `${generateTenantTypeToTranslationMap(t).get(props.tenantData.type)}:
                             ${generateTierToTranslationMap(t).get(props.tenantData?.tenantTier)}`
                            : ""}
                    </Heading>
                </div>
                <div>
                    <button
                        className={bmpSetupStyle.linkText}
                        onClick={() => window.open("https://www.blancco.com/blancco-cost-bundles-pricing/", "_blank")}
                    >
                        <strong>{t("Onboarding.home.bundlesView")}</strong>
                        <span className={style.iconPadding}>
                            <LinkIcon fillColor={theme.iconFillColor} />
                        </span>
                    </button>
                </div>
            </div>
        </>
    );
};

export default CurrentPlan;
